import Vue from "@/main";
import { Message } from "element-ui";

export let graphicLayer; // 矢量图层对象
export let graphicLayer2; // 矢量图层对象
export let graphics = null; //
export let graphicsList = []; //

export function Initialization() {
  graphicLayer = new mars3d.layer.GraphicLayer({
    hasEdit: true,
    isAutoEditing: true, // 绘制完成后是否自动激活编辑
  });
  Vue.$GLOBAL.map.addLayer(graphicLayer);

  graphicLayer.on(mars3d.EventType.click, function(event) {
    setEditor(event);
  });

  graphicLayer2 = new mars3d.layer.GraphicLayer();
  Vue.$GLOBAL.map.addLayer(graphicLayer2);
}

export function startDrawModel(item) {
  mars3d.Lang["_加载模型中"][mars3d.LangType.ZH] = "单击完成绘制";
  graphicLayer.startDraw({
    type: "model",
    name: item.name,
    drawShow: false, // 绘制时，是否显示模型，可避免在3dtiles上拾取坐标存在问题。
    style: item.style,
    // clampToGround: false,

    success: (graphic) => {
      setEditor(graphic);
    },
  });
}

export function addDemoGraphic(item, value) {
  graphicLayer2.clear();
  // graphicLayer2.on(mars3d.EventType.click, function(event) {
  //   console.log(event, "event");
  // });
  graphicsList = [];
  value.forEach((el) => {
    var graphic = new mars3d.graphic.ModelEntity({
      name: item.name,
      position: el,
      style: {
        url: item.style.url,
        scale: 1,
      },
    });
    graphicsList.push(graphic);
    graphicLayer2.addGraphic(graphic);
  });
}

export function stopDraw() {
  graphicLayer.stopDraw();
}
export function temporaryData(value) {
  graphics = value;
}

export function setStyleFun(obj) {
  if (graphics) graphics.setStyle(obj);
}
export function setStyleFuns(obj) {
  graphicLayer2.eachGraphic((graphic) => {
    graphic.setStyle(obj);
  });
}
function setEditor(e) {
  Vue.$eventBus.$emit("startDrawSuccess");
  setTimeout(() => {
    Vue.$eventBus.$emit("warehouseModel", {
      graphics: e.graphic ? e.graphic : e,
    });
  }, 500);
}
export function onSubmit(form) {
  return graphics.toGeoJSON();
}
export function batchCreate() {
  let arr = [];
  graphicLayer2.eachGraphic((graphic) => {
    arr.push(graphic.toGeoJSON());
  });
  return arr;
}
export function deleteGraphic() {
  console.log("删除单个");
  graphicLayer.removeGraphic(graphics);
}
export function deleteAll() {
  console.log("删除所有");
  if (graphicLayer) graphicLayer.clear();
  if (graphicLayer2) graphicLayer2.clear();
  graphics = null;
}
